/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { IonApp, IonRouterOutlet, IonSplitPane } from '@ionic/react';
import NewVersionCheck from 'components/NewVersionCheck';
import { IonReactRouter } from '@ionic/react-router';
import { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxCommandCreator } from 'appRedux/actions';
import { StripeApp } from 'pages/Stripe';
import { LinkPlayer } from 'pages/Signup/views/LinkPlayer';
import { UserConfirm } from 'pages/Signup/views/UserConfirm';
import { Verified } from 'pages/Signup/views/Verified';
import { VerifyAccount } from 'pages/Signup/views/VerifyAccount';
import { CreateAccount } from 'pages/Signup/views/CreateAccount';
import { NewUser } from 'pages/Signup/views/NewUser';
import { ForgotPassword } from 'pages/Signup/views/ForgotPassword';
import { ResetPassword } from 'pages/Signup/views/ResetPassword';
import { EnterpriseForgotPassword } from 'pages/Signup/views/EnterpriseForgotPassword';
import { EnterpriseResetPassword } from 'pages/Signup/views/EnterpriseResetPassword';
import { AdminDashboard } from 'pages/AdminDashboard';
import {
  ProtectedRoute,
  ProtectedRouteCasinoAdmin,
  ProtectedRouteEnterpriseReporting,
  ProtectedRouteCloakTheEgms,
  ProtectedRouteEmulatePlayers,
  ProtectedRouteSystemDashboard,
  ProtectedRouteCreateCasinoAccount,
  ProtectedRouteDeleteCasinoAccounts,
  ProtectedRouteManufacturersManagement,
  ProtectedRouteGameNamesManagement,
} from 'ProtectedRoute';
import { EmulatePlayersPage } from 'pages/EmulatePlayers';
import { SystemDashboardPage } from 'pages/SystemDashboard';
import { DeleteCasinoAccountsPage } from 'pages/DeleteCasinoAccounts';
import { ManufacturersManagementPage } from 'pages/ManufacturersManagement';
import { GameNamesManagementPage } from 'pages/GameNamesManagement';
import TabRootPage from 'components/CasinoTabBar';
import UserProfile from 'pages/userProfile/UserProfile';
import EditProfile from 'pages/EditProfile/EditProfile';
import MyCasinos from 'pages/MyCasinos/MyCasinos';
import ChangePassword from 'pages/ChangePassword/ChangePassword';
import TermsPage from 'pages/TermsPage';
import Notifications from 'pages/Notifications';
import { CasinoAdminDashboard } from 'pages/CasinoAdminDashboard';
import { PlayerEngagementReportPage } from 'pages/Reports/PlayerEngagement';
import { SlotCheckEngagementReportPage } from 'pages/Reports/SlotCheckEngagement';
import { PlayerDevelopmentReportPage } from 'pages/Reports/PlayerDevelopment';
import { CloakEgmsPage } from 'pages/CloakEgms';
import { ChooseCasinos } from 'pages/Signup/views/ChooseCasinos';
import { UniversalSearchPage } from 'pages/UniversalSearch';
import SideMenu from 'components/SideMenu/SideMenu';
import { SubscriptionCancel } from './components/subscriptionCancel';
import { ProcessSuccess } from './components/processSuccess';
import { getDeviceOrientation } from 'common/common';
import { debounce } from 'lodash';
import { Login } from 'pages/Signup/views/Login';
import { LaunchPage } from 'pages/LaunchPage';
import Contact from 'pages/Contact/Contact';
import Other from 'pages/Other/Other';
import SupportCenter from 'pages/SupportCenter/SupportCenter';
import Definitions from 'pages/Definitions/Definitions';
import Settings from 'pages/Settings/Settings';
import SettingOptions from 'pages/Settings/SettingOptions';
import { SETTING_OPTIONS_PATH } from 'pages/Settings/settingsOptions';
import NotificationSettings from 'pages/Settings/NotificationSettings';
import NotificationGroupSettings from 'pages/Settings/NotificationGroupSettings';
import LegalDisclaimer from 'pages/Signup/views/LegalDisclaimer';
import LogoutPage from 'pages/Signup/views/Logout';
import { TestEveriLogin } from 'pages/TestEveriLogin';
import { AnalyticsDashboard } from 'pages/Analytics';
import { selectAuthStateTransformed, selectAuthInitialized } from 'appRedux/selectors';
import MyPlayerCards from 'pages/MyPlayerCards/MyPlayerCards';
import PlayerLinkedNotification from 'components/PlayerLinkedNotification';
import { EditCasinos } from 'pages/Signup/views/EditCasinos';
import { IState } from 'appRedux/createStore';
import { CasinoLogin } from 'pages/Signup/views/CasinoLogin';
import { CasinoAccounts } from 'pages/CasinoAccounts';
import SetIcon from 'pages/SetIcon/SetIcon';
import { useLoadApplicationConfigurations } from 'hooks/useApplicationConfigurations';

export const SlotCheckRouter = () => {
  const dispatch = useDispatch();
  const commands = ReduxCommandCreator(dispatch);
  const authState = useSelector(selectAuthStateTransformed);
  const authInitialized = useSelector(selectAuthInitialized);
  // Shared Mongo applicationConfigurations — once after auth for getConfig().
  useLoadApplicationConfigurations();
  const hasUserConfirm = useSelector<IState>(
    (state) => state.app.persistedState.hasUserConfirm
  ) as boolean;

  const orientation = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const hasLargeScreen = window.screen.width >= 768;
    let orientationType = getDeviceOrientation();
    if (!orientationType) {
      orientationType = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    }

    if (hasLargeScreen && !isMobile) {
      orientationType = 'portrait';
    }

    const isLandscape = orientationType === 'landscape';

    return {
      isMobile,
      device: navigator.maxTouchPoints ? 'mobile' : 'computer',
      orientation: orientationType,
      isLandscape,
      isOnlyPortrait: false,
    };
  };

  useEffect(() => {
    const initialOrientation = orientation();
    commands.SetOrientation(initialOrientation);

    const debouncedDetect = debounce(() => {
      const newOrientation = orientation();
      commands.SetOrientation(newOrientation);
    }, 200);

    const screenOrientation: ScreenOrientation | undefined =
      (window as any).screen && (window as any).screen.orientation
        ? (window as any).screen.orientation
        : undefined;
    const screenHandler = () => debouncedDetect();
    if (screenOrientation && typeof (screenOrientation as any).addEventListener === 'function') {
      (screenOrientation as any).addEventListener('change', screenHandler);
    } else if (screenOrientation && 'onchange' in screenOrientation) {
      try {
        (screenOrientation as any).onchange = screenHandler;
      } catch (e) {}
    }

    let mql: MediaQueryList | null = null;
    let mqlHandler: ((this: MediaQueryList, ev: MediaQueryListEvent) => void) | null = null;
    try {
      mql = window.matchMedia('(orientation: portrait)');
      mqlHandler = () => debouncedDetect();
      if (mql.addEventListener) {
        mql.addEventListener('change', mqlHandler as any);
      } else if ((mql as any).addListener) {
        (mql as any).addListener(mqlHandler as any);
      }
    } catch (e) {
      mql = null;
      mqlHandler = null;
    }

    window.addEventListener('orientationchange', debouncedDetect);
    window.addEventListener('resize', debouncedDetect);

    debouncedDetect();

    return () => {
      debouncedDetect.cancel();

      if (
        screenOrientation &&
        typeof (screenOrientation as any).removeEventListener === 'function'
      ) {
        (screenOrientation as any).removeEventListener('change', screenHandler);
      } else if (screenOrientation && 'onchange' in screenOrientation) {
        try {
          (screenOrientation as any).onchange = null;
        } catch (e) {}
      }

      if (mql && mqlHandler) {
        if (mql.removeEventListener) {
          mql.removeEventListener('change', mqlHandler as any);
        } else if ((mql as any).removeListener) {
          (mql as any).removeListener(mqlHandler as any);
        }
      }

      window.removeEventListener('orientationchange', debouncedDetect);
      window.removeEventListener('resize', debouncedDetect);
    };
  }, [commands]);

  // Guard against blank screen during Redux rehydration after logout.
  // authInitialized is false only in the brief window between app mount and
  // localStorage state being read into Redux (typically < 100ms).
  if (!authInitialized) {
    return (
      <IonApp className="root app-parent m-main">
        <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', backgroundColor: '#000' }} />
      </IonApp>
    );
  }

  return (
    <IonApp className="root app-parent m-main">
      <IonReactRouter>
        <IonSplitPane contentId="main" when="false" slot="end">
          <SideMenu />
          <NewVersionCheck />
          {authState && <Route path="/tabs" render={() => <PlayerLinkedNotification />} />}
          <IonRouterOutlet id="main">
            <Route
              exact
              path={['/canceled']}
              render={() => {
                return <Redirect to="/auth/stripe" />;
              }}
            />
            <Route path="/logout" component={LogoutPage} />
            <Route exact path="/auth/stripe" component={StripeApp} />
            <Route path="/success/:sessionId" component={ProcessSuccess} />
            <Route path="/subscription_canceled" component={SubscriptionCancel} />
            {authState ? (
              <>
                <Route
                  exact
                  path="/"
                  render={() => {
                    if (authState && typeof hasUserConfirm !== 'undefined') {
                      return hasUserConfirm ? (
                        <Redirect to="/auth/userconfirm" />
                      ) : (
                        <Redirect to="/auth/choosecasinos" />
                      );
                    }

                    return <div style={{ padding: 20 }}>Loading...</div>;
                  }}
                />
                <Route path="/auth/choosecasinos" component={ChooseCasinos} />
                {/* Slot Check Search: signed-in only; the page itself redirects (replace) to
                    /auth/choosecasinos unless users.slotCheckSearchEnabled is 1 / "1". */}
                <Route exact path="/universal-search" component={UniversalSearchPage} />
                <Route path="/auth/edit-primary-casino" component={EditCasinos} />

                <Route path="/auth/link-player/:casinoIDParam" component={LinkPlayer} />
                <Route path="/myPlayerCards" component={MyPlayerCards} />

                <Route path="/casinos" component={MyCasinos} />
                <Route path="/profile" component={UserProfile} />
                <Route path="/set-icon" component={SetIcon} />
                <Route path="/editprofile" component={EditProfile} />
                <Route path="/changepassword" component={ChangePassword} />
                <Route path="/contact-us" component={Contact} />
                <Route path="/other" component={Other} />
                <Route path="/settings" exact component={Settings} />
                <Route path="/settings/notifications" exact component={NotificationSettings} />
                <Route
                  path="/settings/notifications/:group"
                  exact
                  component={NotificationGroupSettings}
                />
                <Route path={SETTING_OPTIONS_PATH} exact component={SettingOptions} />
                <Route path="/support-center" component={SupportCenter} />
                <Route path="/definitions" component={Definitions} />
                <Route path="/notifications" component={Notifications} />
                <Route path="/tabs" component={TabRootPage} />
                <Route path="/detail" component={TabRootPage} />
                <Route path="/auth/legalDisclaimer" component={LegalDisclaimer} />
                <Route path="/terms" component={TermsPage} />
                <Route exact path="/auth/userconfirm" component={UserConfirm} />

                <ProtectedRoute path="/admin/testEveriLogin" component={TestEveriLogin} />
                <ProtectedRoute path="/admin/dashboard" component={AdminDashboard} />
                <ProtectedRoute path="/admin/analytics" component={AnalyticsDashboard} />

                <ProtectedRouteCasinoAdmin
                  path="/admin/casino"
                  component={CasinoAdminDashboard}
                />
                <ProtectedRouteEnterpriseReporting
                  path="/reports/player-engagement"
                  component={PlayerEngagementReportPage}
                />
                <ProtectedRouteEnterpriseReporting
                  path="/reports/slot-check-engagement"
                  component={SlotCheckEngagementReportPage}
                />

                <ProtectedRouteEnterpriseReporting
                  path="/reports/player-development"
                  component={PlayerDevelopmentReportPage}
                />


                <ProtectedRouteCloakTheEgms path="/cloak-egms" component={CloakEgmsPage} />
                <ProtectedRouteEmulatePlayers
                  path="/emulate-players"
                  component={EmulatePlayersPage}
                />
                <ProtectedRouteDeleteCasinoAccounts
                  path="/delete-casino-accounts"
                  component={DeleteCasinoAccountsPage}
                />
                <ProtectedRouteSystemDashboard
                  path="/system-dashboard"
                  component={SystemDashboardPage}
                />
                <ProtectedRouteManufacturersManagement
                  path="/manufacturers-management"
                  component={ManufacturersManagementPage}
                />
                <ProtectedRouteGameNamesManagement
                  path="/game-names-management"
                  component={GameNamesManagementPage}
                />

                <ProtectedRouteCreateCasinoAccount
                  path="/admin/addaccount"
                  component={CasinoAccounts}
                />
                <Route
                  exact
                  path="/join-challenge/:challengeId"
                  render={(routeProps) => (
                    <Redirect
                      to={{
                        pathname: `/tabs/join-challenge/${routeProps.match.params.challengeId}`,
                        state: routeProps.location.state,
                      }}
                    />
                  )}
                />
                <Route
                  exact
                  path="/join-challenge"
                  render={(routeProps) => (
                    <Redirect
                      to={{
                        pathname: '/tabs/challenges',
                        state: routeProps.location.state,
                      }}
                    />
                  )}
                />
              </>
            ) : (
              <>
                <Route exact path="/" component={LaunchPage} />
                <Route exact path="/auth/login" component={Login} />
                <Route exact path="/auth/casinoadmin" component={CasinoLogin} />
                <Route exact path="/auth/forgotpassword" component={ForgotPassword} />
                <Route exact path="/auth/resetpassword" component={ResetPassword} />
                <Route exact path="/auth/enterprise-forgotpassword" component={EnterpriseForgotPassword} />
                <Route exact path="/auth/enterprise-resetpassword" component={EnterpriseResetPassword} />
                <Route exact path="/auth/createaccount" component={CreateAccount} />
                <Route path="/terms" component={TermsPage} />
                <Route path="/contact-us" component={Contact} />
                <Route path="/notifications" component={Notifications} />
                <Route exact path="/auth/verifyaccount" component={VerifyAccount} />
                <Route exact path="/auth/verified" component={Verified} />
                <Route exact path="/auth/new" component={NewUser} />
                {/* Emulate Players is staff-only; deep links without a session must refuse. */}
                <Route path="/emulate-players" render={() => <Redirect to="/" />} />
              </>
            )}
          </IonRouterOutlet>
        </IonSplitPane>
        
      </IonReactRouter>
    </IonApp>
  );
};
